//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ykForm",
  props: ["disabled", "labelWidth", "onEnter", "rules", "model", "editType", "inputWidth", "labelPosition", "unreset"],
  data: function data() {
    return {
      modelData: {},
      saveData: {}
    };
  },
  methods: {
    save: function save() {
      var t = this;
      setTimeout(function () {
        t.modelData = {
          base: t.model
        };
        t.saveData = {
          base: JSON.parse(JSON.stringify(t.model))
        };
      }, 10);
    },
    resetData: function resetData() {
      if (this.model !== undefined) {
        var mymodelDate = this.modelData.base;
        var mysaveData = this.saveData.base;
        for (var i in mymodelDate) {
          if (mysaveData[i] === undefined) {
            mymodelDate[i] = "";
          } else {
            if (this.unreset !== undefined) {
              for (var k = 0; k < this.unreset.length; k++) {
                if (this.unreset[k] !== i) {
                  if (typeof mymodelDate[i] === "string" || typeof mymodelDate[i] === "number") {
                    mymodelDate[i] = mysaveData[i];
                  } else {
                    mymodelDate[i] = JSON.parse(JSON.stringify(mysaveData[i]));
                  }
                }
              }
            } else {
              if (typeof mymodelDate[i] === "string" || typeof mymodelDate[i] === "number") {
                mymodelDate[i] = mysaveData[i];
              } else {
                mymodelDate[i] = JSON.parse(JSON.stringify(mysaveData[i]));
              }
            }
          }
        }
        console.log("this.modelData", this.modelData);
        this.onFormEnter();
      } else {
        console.error("from model 字段未绑定！");
      }
    },
    onFormEnter: function onFormEnter() {
      this.$emit("onEnter");
    },
    clearValidate: function clearValidate(callback) {
      this.$refs.myfrom.clearValidate(callback);
    },
    validate: function validate(callback) {
      this.$refs.myfrom.validate(callback);
    },
    resetFields: function resetFields(callback) {
      this.$refs.myfrom.resetFields(callback);
    },
    isChange: function isChange() {
      if (this.model !== undefined) {
        var mymodelDate = this.modelData.base;
        var mysaveData = this.saveData.base;
        for (var i in mymodelDate) {
          if (typeof mymodelDate[i] === "string" || typeof mymodelDate[i] === "number") {
            if (mysaveData[i] !== mymodelDate[i]) {
              return true;
            }
          }
        }
      } else {
        console.error("from model 字段未绑定！");
        return false;
      }
      return false;
    }
  },
  mounted: function mounted() {
    if (this.model !== undefined) {
      this.save();
    }
  },
  watch: {}
};